import { deepMerge, htmlToNode } from 'js/utils/Utils'

const defaults = {
  instanceName: 'elementMask',
  $names: {
    target: '[data-mask]',
  },
  classNames: {
    item: 'mask_i',
    inner: 'mask_in',
  },
  dataNames: {
    tagType: 'maskTagType',
    hasInner: 'maskHasInner',
    display: 'maskDisplay', // ← 追加
  },
  _getTemplate: {
    default: {
      div: (_this, value, display) => {
        return `<div class="${_this.classNames.inner}" style="display: ${display};">${value}</div>`
      },
      span: (_this, value, display) => {
        return `<span class="${_this.classNames.inner}" style="display: ${display};">${value}</span>`
      },
    },
    hasInner: {
      div: (_this, value, display) => {
        return `<div class="${_this.classNames.item}" style="display: ${display}; overflow: hidden; overflow: clip;">
                    <div class="${_this.classNames.inner}" style="display: block;">${value}</div>
                </div>`
      },
      span: (_this, value, display) => {
        return `<span class="${_this.classNames.item}" style="display: ${display}; overflow: hidden; overflow: clip;">
                    <span class="${_this.classNames.inner}" style="display: flex;">${value}</span>
                </span>`
      },
    },
  },
}

export default class ElementMask {
  constructor(options = {}) {
    this.$contentRoot = document
    this.$targets = null

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()

    if (this._hasTargetLength()) {
      this.$targets.forEach(($target) => {
        this._run($target)
      })
    }
  }

  _set$() {
    this.$targets = this.$contentRoot.querySelectorAll(this.$names.target)
  }

  _run($target) {
    let $el,
      str = this._unEscapeHTML($target.innerHTML),
      isSpan = this._isSpan($target),
      hasInner = this._hasInner($target),
      display = this._getDisplay($target)

    $target.innerHTML = ''

    if (hasInner) {
      if (isSpan) {
        $el = htmlToNode(this._getTemplate.hasInner.span(this, str, display))
      } else {
        $el = htmlToNode(this._getTemplate.hasInner.div(this, str, display))
      }
    } else {
      $target.style.overflow = 'hidden'
      $target.style.overflow = 'clip'

      if (isSpan) {
        $el = htmlToNode(this._getTemplate.default.span(this, str, display))
      } else {
        $el = htmlToNode(this._getTemplate.default.div(this, str, display))
      }
    }

    $target.appendChild($el[0])
  }

  _getDisplay($target) {
    const value = $target.dataset[this.dataNames.display]
    if (value === 'block') return 'block'
    if (value === 'inline') return 'inline-block'
    if (value === 'inline-flex') return 'inline-flex'
    if (value === 'flex') return 'flex'
    return 'inline-block' // デフォルト
  }

  _unEscapeHTML(str) {
    return str
      .replace(/(&lt;)/g, '<')
      .replace(/(&gt;)/g, '>')
      .replace(/(&quot;)/g, '"')
      .replace(/(&#39;)/g, "'")
      .replace(/(&amp;)/g, '&')
  }

  _hasTargetLength() {
    return this.$targets.length
  }

  _hasInner($target) {
    return $target.dataset[this.dataNames.hasInner] !== undefined
  }

  _isSpan($target) {
    return $target.dataset[this.dataNames.tagType] === 'span' || $target.dataset[this.dataNames.tagType] === 's'
  }

  _isBlank(value) {
    return /[\t\s]/g.test(value)
  }
}